import { environment } from '../../../../environments/environment';


// INSTITUCIONAL
export const URL_INSTITUCIONAL = environment.urlInstitucional;

// ADMIN
const URL_ADMIN_SESSION = environment.urlLoginAdmin;
const URL_ADMIN_API = environment.urlApiAdmin;
const URL_ADMIN_COMUNICADO = `${URL_ADMIN_API}comunicado/`;
const URL_ADMIN_CONFIGS = `${URL_ADMIN_API}configs/`;
const URL_ADMIN_CONFIGS_LOGIN = `${URL_ADMIN_API}configs/login`;
const URL_ADMIN_PRESTADOR = `${URL_ADMIN_API}prestador/`;

export let adminBuscarComunicados = (paginado, nPagina, nQtdPorPagina) => {
  const param = `/?paginado=${paginado}&nPagina=${nPagina}&nQtdPorPagina=${nQtdPorPagina}`;

  return `${URL_ADMIN_COMUNICADO}${param}`;
};

export let adminInserirComunicado = () => `${URL_ADMIN_COMUNICADO}`;
export let adminExcluirComunicado = (id) => {
  return `${URL_ADMIN_COMUNICADO}${id}/excluir`;
};

export let adminBuscarConfigs = () => `${URL_ADMIN_CONFIGS}`;
export let adminBuscarConfigsLogin = () => `${URL_ADMIN_CONFIGS_LOGIN}`;
export let adminSalvarConfigs = () => `${URL_ADMIN_CONFIGS}salvar`;
export let adminBuscarSiebelConfigs = () => `${URL_ADMIN_CONFIGS}siebel`;
export let adminSalvarSiebelConfigs = () => `${URL_ADMIN_CONFIGS}siebel/salvar`;
export let adminBuscarEmailConfigs = () => `${URL_ADMIN_CONFIGS}email`;
export let adminSalvarEmailConfigs = () => `${URL_ADMIN_CONFIGS}email/salvar`;
export let adminBuscarChatbotConfigs = () => `${URL_ADMIN_CONFIGS}chatbot`;
export let adminSalvarChatbotConfigs = () => `${URL_ADMIN_CONFIGS}chatbot/salvar`;
export let adminBuscarTokenGTOConfigs = () => `${URL_ADMIN_CONFIGS}token`;
export let adminSalvarTokenGTOConfigs = () => `${URL_ADMIN_CONFIGS}token/salvar`;

export let adminDadosCadastraisPrestador = (codigo) => {
  return `${URL_ADMIN_PRESTADOR}${codigo}`;
};

// PRESTADOR
const URL_SESSION = environment.urlLogin;
const URL_API = environment.urlApi;
const URL_GTO = `${URL_API}gto/`;
const URL_PROCEDIMENTO = `${URL_API}procedimento/`;
const URL_PRESTADOR = `${URL_API}prestador/`;
const URL_COMUNICADO = `${URL_API}comunicado/`;
const URL_ELEGIBILIDADE = `${URL_API}beneficiario`;
const URL_DEM_PAG_ANALITICO = `${URL_API}prestador/pagamento/analitico`;
const URL_DEM_PAG_SINTETICO = `${URL_API}prestador/pagamento/sintetico`;
export const URL_MAIN = environment.urlMain;

export let cancelarGTO = numeroGTO => `${URL_GTO}${numeroGTO}/cancelar`;
export let prorrogarGTO = numeroGTO => `${URL_GTO}${numeroGTO}/prorrogar`;
export let imprimirGTO = numeroGTO => `${URL_GTO}${numeroGTO}/imprimir`;
export let excluirItem = numeroGTO => `${URL_GTO}${numeroGTO}/cancelar-item`;
export let salvarProcedimentos = numeroGTO => `${URL_GTO}${numeroGTO}/salvar-data-de-realizacao`;
export const salvarGTO = `${URL_GTO}salvar`;
export const enviarNovaGTO = `${URL_GTO}enviar`;
export let finalizarGTO = (numeroGTO) => `${URL_GTO}${numeroGTO}/finalizar`;

export let buscarComunicados = (qtdeComunicados) => {
  const param = qtdeComunicados
    ? `/?nQtdPorPagina=${qtdeComunicados}&paginado=true`
    : '';
  return `${URL_COMUNICADO}${param}`;
};
export let buscarUltimosComunicados = (qtdeComunicados) => {
  const param = qtdeComunicados ? `/?nQtdPorPagina=${qtdeComunicados}` : '';
  return `${URL_COMUNICADO}ultimos/${param}`;
};

export let comunicadoLido = (comunicadoId) =>
  `${URL_COMUNICADO}${comunicadoId}/lido`;
export let comunicadoEstouDeAcordo = (comunicadoId) =>
  `${URL_COMUNICADO}${comunicadoId}/deacordo`;
export let esqueceuSenha = () => `${URL_SESSION}esqueci-senha`;
export let URL_ALTERAR_SENHA = `${URL_PRESTADOR}alterar-senha`;
export let URL_ALTERAR_IMAGEM_PRESTADOR = `${URL_PRESTADOR}imagem/anexar/`;

export let consultarElegibilidade = (codigoBeneficiario, cpfBeneficiario) =>
  `${URL_ELEGIBILIDADE}?codigo=${codigoBeneficiario}&cpf=${cpfBeneficiario}`;

// Buscar GTOs
export let URL_SITUACOES = `${URL_GTO}situacoes`;
export let URL_PRESTADOR_EXECUTANTE = `${URL_PRESTADOR}corpo-clinico`;
export let URL_COUNT_PENDENTES = `${URL_GTO}qtd-pendentes`;

// Nova GTOs
export let URL_TIPO_ATENDIMENTOS = `${URL_GTO}tipos-atendimento`;
export let URL_DENTISTAS_RADIOLOGIA = `${URL_GTO}dentistas-radiologia`;
export let primeiraOrtodontia = (codigoBeneficiario) =>
  `${URL_GTO}valida-primeira-ortodontia/${codigoBeneficiario}`;
export let buscarProcedimentos = (tipoAtendimento) =>
  `${URL_PROCEDIMENTO}${tipoAtendimento}`;
export let buscarProcedimentoPorCodigo = (
  codigoProcedimento,
  tipoAtendimento
) => {
  return `${URL_PROCEDIMENTO}${codigoProcedimento}/${tipoAtendimento}`;
};
export let buscarDentesAreas = (codigoProcedimento) =>
  `${URL_PROCEDIMENTO}${codigoProcedimento}/dente-area`;
export let buscarFaces = (codigoProcedimento, codigoDenteArea) => {
  return `${URL_PROCEDIMENTO}${codigoProcedimento}/dente-area/${codigoDenteArea}/face`;
};
export const buscarDentistasRadiologia = `${URL_DENTISTAS_RADIOLOGIA}`;
export let anexar = () => `${URL_GTO}anexar`;
export let URL_DOCUWARE = environment.urlDocuware;

// Recupera Demonstrativo de pagamento analítico
export let recuperarDemonstrativoPagAnalitico = (dataCompetencia) =>
  `${URL_DEM_PAG_ANALITICO}?dataCompetencia=${dataCompetencia}`;

// Recupera Demonstrativo de pagamento sintético
export let recuperarDemonstrativoPagSintetico = (dataCompetencia) =>
  `${URL_DEM_PAG_SINTETICO}?dataCompetencia=${dataCompetencia}`;
export let buscarSituacoesETiposAnexo = () => `${URL_GTO}situacoes-tipos-anexo`;
export let buscarSituacoesETiposAnexoAutorizacaoVinculacao = () =>
  `${URL_GTO}situacoes-tipos-anexo-autorizacao`;

// Chatbot
export const URL_GERAR_PROTOCOLO = `${URL_API}chatbot/gerar-protocolo/`;
export const URL_REGISTRAR_CONVERSA = `${URL_API}chatbot/registrar-conversa/`;
export const URL_ENVIAR_CONVERSA = `${URL_API}chatbot/enviar-conversa/`;

// Documentos
export const URL_DOCUMENTOS = `${environment.urlDocumentos}documentos`;
export const listarContratos = (page: number, nItemsPerPage: number) =>
  `${URL_DOCUMENTOS}?pagina=${page}&tamanhoPagina=${nItemsPerPage}`;
export const buscarContrato = (id: number) => `${URL_DOCUMENTOS}/${id}`;
export const tiposContrato = () => `${URL_DOCUMENTOS}/tipos`;
export const editarContrato = (id: number) => `${URL_DOCUMENTOS}/${id}`;
export const exportarAssinaturas = (id: number) => `${URL_DOCUMENTOS}/${id}/assinatura/exportar`;
export const downloadArquivoVinculo = (id: number) => `${URL_DOCUMENTOS}/${id}/vinculo/exportar`;
export const deletarContrato = (id: number) => `${URL_DOCUMENTOS}/${id}`;
export const uploadCSV = (id: number) => `${URL_DOCUMENTOS}/${id}/upload`;
export const vincularPrestadores = (id: number) => `${URL_DOCUMENTOS}/${id}/vincular`;
export const buscarContratosPrestador = (prestador: number) => `${URL_DOCUMENTOS}/prestador/${prestador}`;
export const assinarContrato = (id: number, prestador: number) => `${URL_DOCUMENTOS}/${id}/assinatura/${prestador}`;

export const servicoIp = () => environment.urlIp;

// Token
export const criarTokenGto = () => `${environment.urlToken}/createToken`;
export const configsTokenGto = () => `${environment.urlApi}token/configs`;
export const enviarTokenGto = () => `${environment.urlToken}/sendClientToken`;
export const listaJustificativas = () => `${environment.urlApi}token/lista-justificativas`;
export const salvarJustificativa = () => `${environment.urlApi}token/salvar/justificativa`;
export const salvarTokenGto = () => `${environment.urlApi}token/salvar`;
export const validarTokenGto = () => `${environment.urlToken}/validateClientToken`;

// Beneficiario
export const dadosCadastraisBeneficiario = (codigoBeneficiario: String) => `${URL_API}beneficiario/${codigoBeneficiario}`;

// Firebase
const URL_FIREBASE = environment.firebase;
export let materialApoio = () => `${URL_FIREBASE}/materialApoio.json`;
export let popupMensagem = () => `${URL_FIREBASE}/popup/mensagem.json`;
export let popupAlvo = (username: string) =>
  `${URL_FIREBASE}/popup/alvos/${username}.json`;



// WEBPACK FOOTER //
// ./src/app/components/base/util/url-util.ts